require('slick-carousel')

function productsSlider() {
    var $slider = $('.js-products-slider')

    $slider.slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    })
}
productsSlider();

function newsItems() {
    var $slider = $('.js-news')

    $slider.slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    })
}
newsItems();

function testimonials() {
    var $slider = $('.testimonials-list')

    $slider.slick({
      arrows: false,
      dots: false,
      infinite: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 6000
  })
}
testimonials();


// Products Category Slider 

function productCategoryNav() {
    var $slider = $('.js-product-category-slider')

    $slider.on('init', function (event, slick) {
      updateProductCategorySliderNav(slick)
    })

    $slider.slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
    })

  $slider.on('breakpoint', function (event, slick) {
    updateProductCategorySliderNav(slick)
  })
}
productCategoryNav();

function updateProductCategorySliderNav(slick) {
  var $slider = $('.js-product-category-slider')
  var toShow = 7

  if (slick.activeBreakpoint) {
    toShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow
  }

  $slider.toggleClass('not-slider', slick.slideCount <= toShow)
}


function productCategoryImages() {
  var $slider = $('.js-category-image-list')

  $slider.slick({
    arrows: true,
    dots: true,
    infinite: true,
    fade: false,
    autoplay: true,
    autoplaySpeed: 6000
  })
}
productCategoryImages();


function scbDetailsImages() {
  var $slider = $('.js-scb-details-images')

  $slider.slick({
    arrows: true,
    dots: true,
    infinite: true,
    fade: false
  })
}
scbDetailsImages();


function homepageTopPanel() {
  var $slider = $('.js-header-images')

  $slider.slick({
    arrows: false,
    dots: false,
    infinite: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000
  })
}
homepageTopPanel();


function blogPreview() {
  var $slider = $('.js-blog-preview')

  $slider.slick({
    arrows: false,
    dots: true,
    infinite: true,
    fade: false,
    autoplay: true,
    autoplaySpeed: 6000
  })
}
blogPreview();


function caseStudy() {
  var $slider = $('.js-case-study-images')

  $slider.slick({
    arrows: true,
    dots: true,
    infinite: true,
    fade: false
  })
}
caseStudy();



